import React, { useEffect, useRef } from 'react';

export interface OptionMenuItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  danger?: boolean;
}

interface OptionMenuProps {
  menuItems: OptionMenuItem[];
  isOpen: boolean;
  onClose?: () => void;
}

export const OptionMenu: React.FC<OptionMenuProps> = ({
  menuItems,
  isOpen,
  onClose,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  // --- Handle outside click ---
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose?.();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <div className="absolute right-0 mt-15 w-60 origin-top-right bg-white border border-gray-200 shadow-lg rounded-lg z-50">
        <div className="py-1 text-base">
          {menuItems.map(({ label, icon, onClick, danger }) => (
            <button
              key={label}
              onClick={() => {
                onClick();
                onClose?.(); // close after click
              }}
              className={`w-full text-left p-3 flex items-center gap-3 transition-colors cursor-pointer rounded-md hover:bg-gray-100 ${
                danger ? 'text-red-600' : 'text-gray-800'
              }`}
            >
              {icon}
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
